import Client from "../client";
import { ReleaseTemplateResource, VcsBranchResource } from "client/resources";

export class BranchesRepository {
    constructor(private readonly client: Client) {
        this.client = client;
    }

    getTemplate(branch: VcsBranchResource) {
        return this.client.get<ReleaseTemplateResource>(branch.Links["ReleaseTemplate"]);
    }
}

export default BranchesRepository;
